import { useEffect, useRef } from 'react';
import { initChromaCard } from '../lib/chromaCard.js';

export function ChromaCard({ src, alt, className = 'about-portrait' }) {
  const rootRef = useRef(null);
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return undefined;
    const root = rootRef.current;
    if (!root) return undefined;
    const img = root.querySelector('img');
    if (!img) return undefined;

    let instance = null;
    const mount = () => {
      instance = initChromaCard(root);
    };
    if (img.complete && img.naturalWidth) {
      mount();
    } else {
      img.addEventListener('load', mount, { once: true });
    }

    return () => {
      img.removeEventListener('load', mount);
      instance?.destroy?.();
    };
  }, [src]);

  return (
    <div ref={rootRef} className={className}>
      <img src={src} alt={alt} />
    </div>
  );
}
